import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsappFloat from './components/WhatsappFloat';
import CartDrawer from './components/CartDrawer';
import MusicPlayer from './components/MusicPlayer';
import SEOInjector from './components/SEOInjector';
import Home from './pages/Home';
import AllPujas from './pages/AllPujas';
import PujaDetail from './pages/PujaDetail';
import Participate from './pages/Participate';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import { AboutUs, ContactPage } from './pages/LegalPages';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import { Toaster } from './components/ui/toaster';

function App() {
  useEffect(() => {
    document.title = 'Navavidha Bhakti - Devotional Platform';
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <DataProvider>
        <CartProvider>
        <div className="App min-h-screen bg-[#FFF9F0]">
          <BrowserRouter>
            <SEOInjector />
            <Header />
            <main className="pt-20 md:pt-24">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/upcoming-pujas" element={<AllPujas />} />
                <Route path="/pujas/:slug" element={<PujaDetail />} />
                <Route path="/participate/:slug" element={<Participate />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:id" element={<ProductDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/dashboard" element={<UserDashboard />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsConditions />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/shipping-policy" element={<ShippingPolicy />} />
              </Routes>
            </main>
            <Footer />
            <WhatsappFloat />
            <MusicPlayer />
            <CartDrawer />
            <Toaster />
          </BrowserRouter>
        </div>
        </CartProvider>
        </DataProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
